var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27.273,
    viewBox: "0 0 25 27.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_004-map",
    "data-name": "004-map",
    transform: "translate(-21.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(21.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M155.015,96.7a5.682,5.682,0,1,0-5.682-5.682A5.689,5.689,0,0,0,155.015,96.7Zm0-10.227a4.545,4.545,0,1,1-4.545,4.545A4.55,4.55,0,0,1,155.015,86.469Z",
    transform: "translate(-142.515 -80.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M46.291,26.481l-3.409-7.955a.569.569,0,0,0-.523-.345H40.341l.7-.695a10.228,10.228,0,1,0-14.4,0l.7.7H25.313a.569.569,0,0,0-.523.345l-3.409,7.955a.569.569,0,0,0,.523.792H45.768a.569.569,0,0,0,.523-.792ZM24.745,10.227a9.091,9.091,0,1,1,15.492,6.454l-6.4,6.38-6.4-6.381A9.029,9.029,0,0,1,24.745,10.227Zm-1.98,15.909,2.923-6.818h2.784l4.964,4.948a.567.567,0,0,0,.8,0L39.2,19.318h2.783l2.923,6.818Z",
    transform: "translate(-21.336)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapWhite);
export default __webpack_public_path__ + "static/media/iconMapWhite.a10883efcaac4fa6f67eb4e51d6244d6.svg";
export { ForwardRef as ReactComponent };